import {register} from '@shopify/theme-sections'

import '../../styles/sections/section-headshots.scss'
import $ from "jquery"

export default register(`section-headshots`, {

    onLoad() {
        $(`.headshots-blocks-slider`).slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            responsive: [
              {
                breakpoint: 760,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
        })
    },

    onUnload() {
    },
})
